import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ContractorUserName from "../../components/contractorUser/ContractorUserDetail/ContractorUserName.tsx";
import {useLocationFormState} from "../../components/contractorUser/ContractorUserForm/ContractorUserUpdateForm";
import ContractorUserUpdateFormProvider from "../../components/contractorUser/ContractorUserForm/ContractorUserUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ContractorUserUpdateEditPage = () => {
    
    useTitle(t`Update Contractor User`);

    const { contractorUserId: id } = useParams();
    
    return (
        <Box data-testid="ContractorUser-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="ContractorUser-update-title"
                    >
                        <Trans>Edit Contractor User</Trans>:  <ContractorUserName id={id}/>
                    </Typography>
                    <ContractorUserUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ContractorUserUpdateEditPage;
